<template>
  <div>
    <MenuMovilTP />
    <main class="container mb-4 d-block d-lg-block dkt">
      <Titulo titulo="BUSCADOR DE INSTITUCIONES" subTitulo="CFT e IP" />
      <FormBusqueda @buscarInstitucion="buscarInstitucion" />
    </main>
    <main class="container mb-4 b-inst-univ">
      <TagsBusqueda />
      <b-alert dismissible v-model="showAlert" show
        >No se encontraron resultados para la búsqueda realizada...</b-alert
      >
     
      <VistaTabla :listadoInstituciones="instituciones" />
      <VistaTarjetas
        :listadoContenido="instituciones"
        :modoMovil="true"
        tipoFicha="INSTITUCION"
      />
      <!--<Iconografia />-->
    </main>
    <MenuMovilUni />
  </div>
</template>

<script>
import ApiTecnicoProf from "@/services/ApiTecnicoProf";
import Titulo from "@/components/generales/paginas/TituloPagina";
import FormBusqueda from "@/components/buscadorIP/FormBusqueda";
import Iconografia from "@/components/buscadorIP/Iconografia";
import TagsBusqueda from "@/components/generales/paginas/TagsBusqueda";
import VistaTabla from "@/components/buscadorIP/VistaTabla";
import VistaTarjetas from "@/components/generales/paginas/VistaTarjetas";
import ApiRegiones from "@/services/ApiRegiones";
import MenuMovilTP from "@/components/generales/menuMovil/TecnicoProfesional";
import MenuMovilUni from "@/components/generales/menuMovil/AdmisionUniversitaria";

import { mapGetters } from "vuex";
export default {
  name: "BuscadorIP",
  components: {
    Titulo,
    FormBusqueda,
    Iconografia,
    TagsBusqueda,
    VistaTabla,
    VistaTarjetas,
    MenuMovilTP,
    MenuMovilUni
  },
  data() {
    return {
      busquedaActual: {},
      instituciones: [],
      showAlert: false
    };
  },
  mounted() {
    this.reiniciarBusqueda();
  },
  computed: {
    ...mapGetters(["getBusquedasAplicadas"])
  },
  methods: {
    async buscarInstitucion(busqueda) {
      this.$emit("cargar");
      if (
        busqueda.region !== null ||
        busqueda.beneficiosEstatales !== null ||
        busqueda.tipoInstitucion !== null ||
        busqueda.nombreInstitucion !== ""
      ) {
        this.busquedaActual = busqueda;
        let instituciones = await ApiTecnicoProf.getInstituciones(busqueda);
        if (instituciones || instituciones !== "") {
          let dataOrg = this.reorganizarData(instituciones);
          this.instituciones = dataOrg;
          this.showAlert = false;
        } else {
          this.showAlert = true;
          this.instituciones = [];
        }
      } else {
        this.instituciones = [];
      }

      this.$emit("cargado");
    },
    reiniciarBusqueda() {
      let busquedasAplicadas = this.getBusquedasAplicadas;
      let nuevaBusqueda = {
        tipoInstitucion: null,
        region: null,
        beneficiosEstatales: null,
        nombreInstitucion: ""
      };
      if (busquedasAplicadas.length >= 1) {
        busquedasAplicadas.forEach(f => {
          switch (f.tipo) {
            case "REGION":
              nuevaBusqueda.region = f.filtro;
              break;
            case "INSTITUCION":
              nuevaBusqueda.tipoInstitucion = f.filtro;
              break;
            case "BENEFICIOS_ESTATALES":
              nuevaBusqueda.beneficiosEstatales = f.filtro;
              break;
            case "NOMBRE_INSTITUTO":
              nuevaBusqueda.nombreInstitucion = f.filtro;
              break;
            default:
              break;
          }
        });
        this.buscarInstitucion(nuevaBusqueda);
      }
    },
    reorganizarData(listado) {
      let institutos = [];
      for (let inst of listado) {
        let instt = {
          id: inst.id,
          codigo: inst.codigo,
          nombreCorto: inst.nombreCorto,
          nombre: inst.nombre,
          tipoInstitucion: inst.tipoInstitucion,
          acreditado: inst.acreditado,
          acreditacion: inst.acreditacion,
          gratuidad: inst.gratuidad,
          beneficiosEstatales: inst.beneficiosEstatales,
          pantone: inst.pantone ? inst.pantone : "#0b3788",
          web: inst.contacto.paginaWeb,
          region: "",
          observacionAcreditacionCNA: inst.observacionAcreditacionCNA,
          contactoSede: {}
        };
        let sedesContacto = inst.sedes.map(i => {
          let sed = {
            codigoSede: i.codigo,
            nombre: i.nombre,
            region: i.regionNombreCorto,
            regionValor: i.region
          };
          return sed;
        });
        let sedesRegiones = inst.sedes.map(i => i.region);
        sedesRegiones = [...new Set(sedesRegiones)];
        if (
          this.busquedaActual.region !== null &&
          this.busquedaActual.region !== "TODAS"
        ) {
          sedesRegiones = sedesRegiones.filter(
            i => i === this.busquedaActual.region
          );
        }
        sedesRegiones.forEach(s => {
          let nuevaInst = JSON.parse(JSON.stringify(instt));
          let regionFormateada = ApiRegiones.getRegionesYComunas().find(
            r => r.valorBusqueda === s
          );
          nuevaInst.region = regionFormateada.nombreRegion;
          nuevaInst.listadoSedes = sedesContacto.filter(
            sc => sc.regionValor === s
          );
          institutos.push(nuevaInst);
        });
      }
      institutos = this.ordenamientoFinal(institutos);
      return institutos;
    },
    ordenamientoFinal(listado) {
      let ordenado;
      let regiones = ApiRegiones.getSoloRegiones();

      ordenado = listado.sort((a, b) => {
        let n1 = regiones.indexOf(a.region);
        let n2 = regiones.indexOf(b.region);
        return n1 - n2;
      });
      ordenado = ordenado.sort((a, b) => {
        return a.nombreCorto.localeCompare(b.nombreCorto);
      });
      ordenado = ordenado.sort((a, b) => {
        let n1 = a.acreditacion.anios ? a.acreditacion.anios : 0;
        let n2 = b.acreditacion.anios ? b.acreditacion.anios : 0;
        return n2 - n1;
      });
      return ordenado;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/BuscadoresTP/BuscadorIP.vue